import script from "./IbReportExportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IbReportExportModal.vue?vue&type=script&setup=true&lang=ts"

import "./IbReportExportModal.vue?vue&type=style&index=0&id=c27332a4&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c27332a4"]])

export default __exports__